import {isEnrichmentAnswerTypeOptions} from '../filters';

/**
 * Converts an array of option values to an array of corresponding labels based on the given enrichment.
 *
 * @param {Object} enrichment - The enrichment metadata object containing the options.
 * @param {Array} optionValues - The array of option values to be converted.
 * @return {Array} The array of corresponding labels.
 */
export function optionValues2optionLabels(enrichment, optionValues) {
    if (isEnrichmentAnswerTypeOptions(enrichment)) {
        const labels = enrichment.options.reduce((labels, option) => {
            labels[option.value] = option.filter_label || option.label;
            return labels;
        }, {});

        return optionValues.map(value => labels[value]);
    }

    return optionValues;
}
